import { createFileRoute } from "@tanstack/react-router";

import { legalRoute } from "./legal/-components/legalRoute";

export const Route = createFileRoute(
  "/privacy-notice-for-california-residents"
)(legalRoute("privacy-notice-for-california-residents"));
